import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: 'LEX AI' }
  },
  {
    path: '/wechat-callback',
    name: 'WechatCallback',
    component: () => import('@/views/WechatCallback.vue'),
    meta: { 
      title: '微信登录回调',
      hideLayout: true  // 标记这个页面不使用默认布局
    }
  },
  {
    path: '/contract-review',
    name: 'ContractReview',
    component: () => import('@/views/ContractReviewView.vue'),
    meta: { title: '合同审查', requiresAuth: true }
  },
  {
    path: '/search',
    name: 'UnifiedSearch',
    component: () => import('@/views/UnifiedSearchView.vue'),
    meta: { title: '智能检索', requiresAuth: true }
  },
  {
    path: '/case-search',
    name: 'CaseSearch',
    component: () => import('@/views/CaseSearchView.vue'),
    meta: { title: '搜案例', requiresAuth: true }
  },
  {
    path: '/legal-search',
    name: 'LegalSearch',
    component: () => import('@/views/LegalSearchView.vue'),
    meta: { title: '查法规', requiresAuth: true }
  },
  {
    path: '/legal-consultation',
    name: 'LegalConsultation',
    component: () => import('@/views/LegalConsultationView.vue'),
    meta: { title: '法律咨询 - LEX AI', requiresAuth: true }
  },
  {
    path: '/document-management',
    name: 'DocumentManagement',
    component: () => import('@/views/DocumentManagementView.vue'),
    meta: { title: '文件管理 - LEX AI', requiresAuth: true }
  },
  {
    path: '/contract-generation',
    name: 'ContractGeneration',
    component: () => import('@/views/ContractGenerationView.vue'),
    meta: { title: '智能合同助手 - LEX AI', requiresAuth: true }
  },
  {
    path: '/legal-detail/:id',
    name: 'LegalDetail',
    component: () => import('@/views/LegalDetailView.vue'),
    props: true,
    meta: { title: '法规详情', requiresAuth: true }
  },
  {
    path: '/personal-center',
    name: 'PersonalCenter',
    component: () => import('@/views/PersonalCenterView.vue'),
    meta: { title: '个人中心 - LEX AI', requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue'),
    meta: { title: '关于我们 - LEX AI' }
  },
  {
    path: '/account/transactions',
    name: 'TransactionHistory',
    component: () => import('@/views/TransactionHistoryView.vue'),
    meta: { title: '消费记录 - LEX AI', requiresAuth: true }
  },
  {
    path: '/login/success',
    name: 'LoginSuccess',
    component: () => import('@/views/LoginSuccess.vue'),
    meta: { title: '登录成功' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: '页面未找到 - LEX AI' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'LEX AI - 法律辅助工具'

  if (to.meta.requiresAuth) {
    const userStore = useUserStore()
    
    // 先检查本地状态，避免网络请求阻塞
    if (!userStore.isLoggedIn) {
      const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user')
      const storedToken = localStorage.getItem('token') || sessionStorage.getItem('token')
      
      if (storedUser && storedToken) {
        try {
          userStore.user = JSON.parse(storedUser)
          userStore.token = storedToken
          userStore.isLoggedIn = true
        } catch (error) {
          console.error('解析本地用户信息失败:', error);
        }
      }
    }
    
    if (userStore.isLoggedIn) {
      next()
    } else {
      next({
        path: '/',
        query: { showLogin: true, redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

export default router
